import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';

import apiCross from '../../../api/CrossSale';
import ApiCatalog from '../../../api/Catalog/Category';

import Item from '../CrossItem';
import Config, { spanish } from '../../../config/config';

const CrossSale = () => {
  const [content, setContent] = useState(null);
  const [crossSaleProducts, setCrossSaleProducts] = useState(null);
  const stateId = useSelector(
    (globalState) => globalState.estadoSelection.selectedEstadoId
  );

  const getMasterProducts = useCallback(async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      idCategoria: 0,
      IdEstado: stateId,
    };

    const resp = await ApiCatalog.getProductsByCategoryId(payload);
    if (resp.Codigo === 200) {
      setCrossSaleProducts(resp.ListaProductos);
    }
  }, []);
  useEffect(async () => {
    setContent(await apiCross.getItems());
    getMasterProducts();
  }, []);
  const productInfoFirstSKU = crossSaleProducts?.find(
    (item) => item.cve_prod === parseInt(content?.firstSKU, 10)
  );
  const productInfoSecondSKU = crossSaleProducts?.find(
    (item) => item.cve_prod === parseInt(content?.secondSKU, 10)
  );
  const productInfoThirdSKU = crossSaleProducts?.find(
    (item) => item.cve_prod === parseInt(content?.thirdSKU, 10)
  );
  const productInfoFourthSKU = crossSaleProducts?.find(
    (item) => item.cve_prod === parseInt(content?.fourthSKU, 10)
  );

  return (
    <div className={styles.container}>
      {content && (
        <>
          <h5>{spanish ? content?.TitleSpanish : content?.TitleEnglish}</h5>
          <div className={styles.content}>
            <div>
              <Item sku={content?.firstSKU} productInfo={productInfoFirstSKU} />
            </div>
            <div>
              <Item
                sku={content?.secondSKU}
                productInfo={productInfoSecondSKU}
              />
            </div>
            <div>
              <Item sku={content?.thirdSKU} productInfo={productInfoThirdSKU} />
            </div>
            <div>
              <Item
                sku={content?.fourthSKU}
                productInfo={productInfoFourthSKU}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CrossSale;
